import { Box, Typography } from '@mui/material';
import React, { ReactElement, ReactNode } from 'react';
import { Button } from '..';
import { Modal, ModalProps } from './Modal';

export interface ConfirmationModalProps
  extends Omit<ModalProps, 'children' | 'onClose'> {
  message?: string;
  body?: ReactNode;
  cancelAction?: string;
  confirmAction: string;
  onCancel: () => void;
  onConfirm: () => void;
}

export const ConfirmationModal = ({
  title,
  open,
  onCancel,
  onConfirm,
  message,
  body,
  cancelAction = 'Cancel',
  confirmAction,
}: ConfirmationModalProps): ReactElement => {
  return (
    <Modal title={title} open={open} onClose={onCancel}>
      <form
        onSubmit={e => {
          e.preventDefault();
          onConfirm?.();
        }}
      >
        <Typography>{message}</Typography>

        {body}

        <Box
          mt={message ? 20 : 0}
          display="flex"
          alignItems="center"
          flexDirection="column"
        >
          <Box mb={24}>
            <Button type="submit" minWidth={300} variant="vibrant">
              {confirmAction}
            </Button>
          </Box>
          <Typography
            onClick={onCancel}
            sx={{
              '&:hover': {
                textDecoration: 'underline',
                cursor: 'pointer',
              },
            }}
          >
            {cancelAction}
          </Typography>
        </Box>
      </form>
    </Modal>
  );
};
